import React from 'react';
import { createRoot } from 'react-dom/client';
import { Amplify } from 'aws-amplify';
// import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';
import Auth0ProviderWithHistory from './Auth0ProviderWithHistory';
import { MuiProLic, awsconfig } from './aws-config';
import App from './App';

// Configure AWS Amplify with Auth0 OIDC
// Auth token is passed directly in each GraphQL call via authToken parameter
Amplify.configure(awsconfig);

LicenseInfo.setLicenseKey(MuiProLic);

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Auth0ProviderWithHistory>
      <App />
    </Auth0ProviderWithHistory>
  </BrowserRouter>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
